// extracted by mini-css-extract-plugin
module.exports = {"spacer":"CommonSpacer_spacer__cThm8","full":"CommonSpacer_full__r_i7U","top":"CommonSpacer_top__DkA7e","bottom":"CommonSpacer_bottom__zCzIh"};